'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactStyle = require('react-style');

var _reactStyle2 = _interopRequireDefault(_reactStyle);

var _ = require('./');

var _style = require('./style');

var _utils = require('./utils');

var IconButtonStyles = _reactStyle2['default'].create({
  normalStyle: {
    cursor: 'pointer',
    display: 'inline-block',
    height: 24,
    padding: 8,
    position: 'relative',
    width: 24,
    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
    outline: 'none'
  },

  circleShadowStyle: {
    backgroundColor: _style.Colors.grey.P400,
    height: 24,
    left: 7,
    padding: 0,
    top: 8,
    transform: 'scale(2) translateZ(0)',
    width: 24
  }
});

var _default = (function (_React$Component) {
  var _class = function _default(props) {
    _classCallCheck(this, _class);

    _get(Object.getPrototypeOf(_class.prototype), 'constructor', this).call(this, props);
  };

  _inherits(_class, _React$Component);

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var icon = _props.icon;
      var onClick = _props.onClick;
      var styles = _props.styles;
      var normalStyle = IconButtonStyles.normalStyle;
      var circleShadowStyle = IconButtonStyles.circleShadowStyle;

      var iconStyles = styles ? styles.iconStyles : null;
      return _react2['default'].createElement(
        'div',
        {
          onClick: function () {
            return onClick();
          },
          styles: normalStyle },
        _react2['default'].createElement(_.CircleShadow, {
          active: true,
          styles: circleShadowStyle }),
        _react2['default'].createElement(_.Icon, {
          icon: icon,
          styles: iconStyles })
      );
    }
  }], [{
    key: 'displayName',
    value: 'IconButton',
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      onClick: _utils.noop
    },
    enumerable: true
  }, {
    key: 'propTypes',
    value: {
      icon: _react.PropTypes.string,
      onClick: _react.PropTypes.func,
      styles: _react.PropTypes.object
    },
    enumerable: true
  }]);

  return _class;
})(_react2['default'].Component);

exports['default'] = _default;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-material/lib/IconButton.js
 ** module id = 206
 ** module chunks = 0
 **/